import React from 'react';
import classNames from 'classnames';
import { MetaLayerDefinition } from '@agissc/ktag-map';
import SelectedTopicLayer from './SelectedTopicLayer';
import DummyTopicLayer from './DummyTopicLayer';

interface DragHandleProps {
  listeners: Record<string, unknown>;
  attributes: Record<string, unknown>;
}

interface SelectedTopicLayerItemProps {
  id: string;
  topicLayer?: MetaLayerDefinition;
  isNotAvailable: boolean;
  isHighlighted: boolean;
  hasError: boolean;
  isVisible: boolean;
  opacity: number;
  onRemove: () => void;
  onToggleVisibility: () => void;
  onOpacityChanged: (value: number) => void;
  dragHandleProps?: DragHandleProps;
  isDragOverlay?: boolean;
}

export const SelectedTopicLayerItem = ({
  id,
  topicLayer,
  isNotAvailable,
  isHighlighted,
  hasError,
  isVisible,
  opacity,
  onRemove,
  onToggleVisibility,
  onOpacityChanged,
  dragHandleProps,
  isDragOverlay,
}: SelectedTopicLayerItemProps) => {
  return (
    <div
      title={topicLayer?.description ?? ''}
      className={classNames('topic-layer__item', {
        'topic-layer__item_highlighted': isHighlighted,
        'topic-layer__item--drag': isDragOverlay,
      })}
    >
      {isNotAvailable ? (
        <DummyTopicLayer topicLayerName={id} onRemove={onRemove} />
      ) : (
        topicLayer && (
          <SelectedTopicLayer
            id={id}
            title={topicLayer.title}
            hasError={hasError}
            onRemove={onRemove}
            isVisible={isVisible}
            onToggleVisibility={onToggleVisibility}
            onOpacityChanged={onOpacityChanged}
            opacity={opacity}
            source={topicLayer.source}
            isPublic={topicLayer.isPublic}
            dragHandleProps={dragHandleProps}
          />
        )
      )}
    </div>
  );
};
